var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fab-container"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red","dark":"","fab":""},on:{"click":_vm.onClick},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Start a new note")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530973a8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteAdd.vue
// module id = 129
// module chunks = 1